<template>
  <modal
    class="meetingsTypes"
    :class="$style.meetingsTypes"
    :header-text="$t('settings.typeOfMeeting')"
    hide-footer="true"
    @close="close()"
  >
    <div :class="$style.wrapper">
      <input id="addType" v-model="newType" name="addType" :class="$style.input">
      <button :class="$style.button" :disabled="isPending" @click="addNewType()">
        {{ $t('global.add') }}
      </button>
    </div>
    <div :class="$style.container">
      <Loader v-if="isPending" />
      <dragTreeTable v-else :data="treeData" :isdraggable="false" @deleteItem="deleteType" @saveNewName="changeType" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/settings-modal.vue';
import Loader from '@/components/common/blocks/loader.vue';
import dragTreeTable from '@/components/pages/agents/drag-tree-table/dragTreeTable.vue';
import { saveNewMeetingType, deleteMeetingType, renameMeetingType } from '@/api/methods/settings';
import { openToast, errorToast, TOAST_TYPE } from '@/utils/open-toast';

export default {
  components: { Modal, Loader, dragTreeTable },
  props: ['types'],
  data() {
    return {
      isPending: false,
      newType: null,
      treeData: {
        columns: [
          {
            type: 'selection',
            title: this.$t('reports.columns.activity'),
            field: 'type',
            width: 100,
            align: 'left',
            sort: 2,
            sorted: true,
            flex: 3,
          },
          {
            type: 'action',
            title: this.$t('settings.columns.action'),
            width: 100,
            align: 'left',
            flex: 1,
            actions: [
              {
                text: this.$t('settings.columns.actions.changeName'),
                eventName: 'changeName',
                formatter: () => '',
              },
              {
                text: this.$t('settings.columns.actions.saveNewName'),
                eventName: 'saveNewName',
                formatter: () => '',
              },
              {
                text: this.$t('settings.columns.actions.deleteItem'),
                eventName: 'deleteItem',
                formatter: () => '',
              },
              {
                text: this.$t('settings.columns.actions.cancelChange'),
                eventName: 'cancelChange',
                formatter: () => '',
              },
            ],
          },
        ],
        lists: this.types,
      },
    };
  },
  watch: {
    types(newVal) {
      if (newVal) this.treeData.lists = this.types;
    },
  },
  methods: {
    async deleteType({ id }) {
      this.isPending = true;
      await deleteMeetingType(id);
      this.isPending = false;

      this.$emit('update');
    },
    async changeType({ id, type }) {
      this.isPending = true;
      await renameMeetingType(id, type);
      this.isPending = false;
      this.$emit('update');
    },
    async addNewType() {
      if (!this.newType) {
        openToast(this.$t('toast.enterType'), TOAST_TYPE.WARNING);

        return;
      }
      this.isPending = true;

      const { data } = await saveNewMeetingType(this.newType);
      this.isPending = false;

      if (data?.success) {
        this.$emit('update');
        openToast(this.$t('toast.typeAddedSuccessfully'), TOAST_TYPE.SUCCSESS);
      } else {
        errorToast();
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style>
  .meetingsTypes .settings-modal_modal_3LaCC {
    width: 20% !important;
  }
</style>
<style lang="scss" module>
  .meetingsTypes {
    z-index: 3;
  }
  .wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0 0 10px;
    height: 34px;
  }

  .input {
    height: 100%;
    padding: 0 7px;
    background: none;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    color: #333;
    line-height: 1.4;
  }
  .button {
    cursor: pointer;
    background: #2985bf;
    border: none;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    opacity: 1;
    height: 100%;
    transition: all 0.3 ease-in-out;
    padding: 10px;
    &:disabled {
      background: $branchColor;
      border: $branchColor;
    }
  }
  .button:hover {
    opacity: 0.8;
    &:disabled {
      opacity: 1;
      background: $branchColor;
      border: $branchColor;
    }
  }
  .button:active {
    background: rgb(73, 173, 106);
    &:disabled {
      background: $branchColor;
      border: $branchColor;
    }
  }

  .container {
    height: 300px;
    overflow-y: auto;
  }
</style>
